<template>
  <div class="operatore-layout">
    <a class="skip-link" href="#operatore-main-content">
      {{ $t("AccessibilityToolbar.skipToContent") }}
    </a>
    <PopupModal v-if="popupEnabled" />
    <FloatingIframe
      v-if="openBancaDati"
      :openBancaDati="openBancaDati"
      @close-banca-dati="openBancaDati = null"
    />

    <div class="w-sm-100 d-md-flex">
      <IdleTracker
        v-if="user.session_timeout_minutes && user.session_timeout_minutes > 0"
        :userSessionTimeout="user.session_timeout_minutes"
      />
      <nav class="nav-desktop" :aria-label="$t('OperatoreMain.nav_label')">
        <NavigationOperatoreCRoom
          v-if="company && company.level === 5"
          :wlistener="innerWidth"
        />

        <NavigationOperatore
          v-else
          :wlistener="innerWidth"
          @open-banca-dati="openBancaDati = $event"
        />
      </nav>

      <div class="w-100 operatore-content">
        <OperatoreTopHeader />
        <CompanyBanner v-if="showCompanyBanner" />

        <main
          id="operatore-main-content"
          class="pt-4 px-2 px-md-3 px-lg-4 main-operatore"
          tabindex="-1"
        >
          <PluginSlot name="operatore-main-top" class="mb-3" />
          <!-- <AccessibilityToolbar /> -->
          <router-view></router-view>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import NavigationOperatore from "@/app/layout/components/NavigationOperatore.vue";
import NavigationOperatoreCRoom from "@/app/layout/components/NavigationOperatoreCRoom.vue";
import IdleTracker from "@/app/common/components/utilities/IdleTracker.vue";
import FloatingIframe from "@/app/modules/statistiche/components/FloatingIframe.vue";
import OperatoreTopHeader from "@/app/layout/components/OperatoreTopHeader.vue";
import CompanyBanner from "@/app/layout/components/CompanyBanner.vue";
import PluginSlot from "@/app/common/components/plugins/PluginSlot.vue";
import PopupModal from "@/app/modules/statistiche/components/PopupModal.vue";

export default {
  name: "OperatoreMain",
  components: {
    NavigationOperatore,
    NavigationOperatoreCRoom,
    IdleTracker,
    FloatingIframe,
    OperatoreTopHeader,
    CompanyBanner,
    PluginSlot,
    PopupModal,
    // FloatingIframeOld
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      openBancaDati: null,
      popupEnabled: process.env.VUE_APP_POPUP_ENABLED,
    };
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
    ...mapState("company", ["companyLoggedIn", "company"]),
    showCompanyBanner() {
      return this.$route.name === "CompanyHome";
    },
    welcomeName() {
      if (
        this.user &&
        this.user.anagrafica &&
        this.user.anagrafica.name &&
        this.user.anagrafica.surname
      ) {
        return (
          this.user.anagrafica.name.toLowerCase() +
          " " +
          this.user.anagrafica.surname.toLowerCase()
        );
      }
      return this.user.username;
    },
  },
  methods: {
    ...mapActions("company", ["logUserCompanyIn", "companyLogin"]),
    innerWidthChanged() {
      // console.log("resize handler");
      this.innerWidth = window.innerWidth;
    },
  },
  created() {
    if (this.user.type !== 1) {
      this.$router.push({ name: "Home" });
    }
    window.addEventListener("resize", this.innerWidthChanged);
  },
  mounted() {
    this.logUserCompanyIn();
    if (
      this.user.expired_password == 1 &&
      this.$route.name !== "profilo operatore"
    ) {
      this.$router.push({
        name: "profilo operatore",
        query: { scope: "expired" },
      });
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
};
</script>

<style lang="scss" scoped>
.operatore-layout {
  position: relative;
}

/* la colonna contenuto è un flex item di .d-md-flex: la utility .w-100 impone width:100%
   ma lascia min-width:auto, quindi non può rimpicciolirsi sotto il min-content del proprio
   contenuto (es. la striscia di pill scorrevole del compilatore a blocchi) e finisce per
   allargare l'intera pagina. min-width:0 le permette di restringersi alla larghezza
   disponibile, così gli elementi interni con overflow-x:auto scorrono internamente. */
.operatore-content {
  min-width: 0;
}

/* la navigazione sta sopra al contenuto (era uno z-index in linea sul <nav>) */
.nav-desktop {
  z-index: 5;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 10px;
  background-color: $white;
  color: $secondary;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  z-index: 3000;
}

.skip-link:focus {
  top: 10px;
}
</style>
